import { Editor } from "@tiptap/core";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";

globalThis.textEditor = {
  initEditor: function(elementId)
  {
    const editorElement = document.getElementById(elementId);

    let editor = new Editor({
      element: editorElement, extensions: [
        StarterKit, Placeholder.configure({
          placeholder: "Haupttext eingeben", emptyEditorClass: "is-editor-empty first:before:float-left first:before:h-0 first:before:pointer-events-none first:before:text-tinted-gray-400"
        }), Link.configure({
          openOnClick: false
        })
      ], content: "", editorProps: {
        attributes: {
          class: "text-sm text-tinted-gray-900 min-h-[300px] w-full format focus:outline-none placeholder:text-blue-500" // Hier setzen wir die Placeholder-Farbe
        }
      }
    });

    const container = editorElement.closest(".text-editor-wrapper");

    // Buttons referenzieren
    const boldButtonEl = container.querySelector("[name=\"toggleBoldButton\"]");
    const italicButtonEl = container.querySelector("[name=\"toggleItalicButton\"]");
    const orderedListButtonEl = container.querySelector("[name=\"toggleOrderedListButton\"]");
    const listButtonEl = container.querySelector("[name=\"toggleListButton\"]");
    const linkButtonEl = container.querySelector("[name=\"toggleLinkButton\"]");
    const clearFormattingEl = container.querySelector("[name=\"clearFormattingButton\"]");

    // Button Aktionen
    if (boldButtonEl)
    {
      boldButtonEl.addEventListener("click", () =>
      {
        editor.chain().focus().toggleBold().run();
        requestAnimationFrame(updateButtonStates);
      });
    }

    if (italicButtonEl)
    {
      italicButtonEl.addEventListener("click", () =>
      {
        editor.chain().focus().toggleItalic().run();
        requestAnimationFrame(updateButtonStates);
      });
    }

    if (orderedListButtonEl)
    {
      orderedListButtonEl.addEventListener("click", () =>
      {
        editor.chain().focus().toggleOrderedList().run();
        requestAnimationFrame(updateButtonStates);
      });
    }

    if (listButtonEl)
    {
      listButtonEl.addEventListener("click", () =>
      {
        editor.chain().focus().toggleBulletList().run();
        requestAnimationFrame(updateButtonStates);
      });
    }

    if (linkButtonEl)
    {
      linkButtonEl.addEventListener("click", () =>
      {
        const url = window.prompt("Enter image URL:", "https://www.vogel.de");
        editor.chain().focus().toggleLink({ href: url }).run();
        requestAnimationFrame(updateButtonStates);
      });
    }

    if (clearFormattingEl)
    {
      clearFormattingEl.addEventListener("click", () =>
      {
        editor.chain().focus()
              .unsetAllMarks()
              .clearNodes()
              .run();
      });
    }


    // Shortcuts erfassen (z.B. Strg+B) und Buttons auf aktiv setzen
    editor.on("transaction", () =>
    {
      requestAnimationFrame(updateButtonStates);
    });


    // Zustand aktualisieren (active styles)
    const updateButtonStates = () =>
    {
      boldButtonEl.classList.toggle("bg-indigo-100", editor.isActive("bold"));
      boldButtonEl.classList.toggle("text-indigo-600", editor.isActive("bold"));

      italicButtonEl.classList.toggle("bg-indigo-100", editor.isActive("italic"));
      italicButtonEl.classList.toggle("text-indigo-600", editor.isActive("italic"));

      orderedListButtonEl.classList.toggle("bg-indigo-100", editor.isActive("orderedList"));
      orderedListButtonEl.classList.toggle("text-indigo-600", editor.isActive("orderedList"));

      listButtonEl.classList.toggle("bg-indigo-100", editor.isActive("bulletList"));
      listButtonEl.classList.toggle("text-indigo-600", editor.isActive("bulletList"));

      linkButtonEl.classList.toggle("bg-indigo-100", editor.isActive("link"));
      linkButtonEl.classList.toggle("text-indigo-600", editor.isActive("link"));
    };

    editor.on("update", updateButtonStates);
    editor.on("selectionUpdate", updateButtonStates);

    return editor;
  }
};


// import { FunnelChart } from 'chartjs-chart-funnel';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import 'htmx.org';
//
// (async function() {
// //     htmx.on("htmx:afterSettle", function(){
//     document.body.addEventListener("htmx:afterSettle", function() {
//         let data = JSON.parse(document.getElementById('linechartconfig').textContent)['data'];
//         // let linechart = null;
//         // if linechart null dann das , if not null update
//         // funktionen: positionselectedchange -> neuepositonid holen, deselect current, select new, getnewdata, refreshchart
//         // funktionen: ondaterangechanged -> neue daten holen, refreshchart
//         // funktionen: refreshchart
//
//         let linechart = new Chart(
//             document.getElementById('linechart'),
//             {
//                 type: 'line',
//                 animation: false,
//                 options: {},
//                 data: {
//                     labels: data.map(row => row.date),
//                     datasets: [
//                         {
//                             label: 'Pageviews',
//                             // data: data.map(row => row.pageviews)
//                             data: data.map(row => row.pageviews),
//                             borderColor: 'rgb(75, 192, 192)',
//                             backgroundColor: 'rgb(211,211,211)',
//                         }
//                     ]
//                 }
//
//             }
//         );
//         let positionButtons = document.getElementsByName('positionId');
//         for (i = 0; i < positionButtons.length; i++){
//             positionButtons[i].addEventListener('click', function (e){
//                 linechart.clear();
//                 linechart.destroy();
//             })
//         }
//     })
// })();
//
